import { filterApiFetch } from './filter-api-client';

// Wire shapes for the Story 4.3 policy-editor endpoints. Filter API speaks
// snake_case at the JSON boundary; role_overrides maps each role to a list of
// prompt-addition lines (textarea split on newlines by the editor).
export interface PolicyFormWire {
  profile: string;
  additional_block_rules: string[];
  role_overrides: Record<string, string[]>;
  rabbi_contact: { name: string; redirect_note: string };
}

export interface PolicyPrefill {
  community: { id: string; slug: string; name: string; profile: string };
  current: PolicyFormWire | null;
}

export interface PolicyChangeCreated {
  id: string;
  community_id: string;
  pr_number: number;
  pr_url: string;
  branch_ref: string;
  title: string;
  diff_summary: string;
  created_at: string;
}

export type PolicyChangeStatus = 'pending' | 'merging' | 'applied' | 'closed';

export interface PolicyChangeItem {
  id: string;
  pr_number: number;
  pr_url: string;
  branch_ref: string;
  title: string;
  diff_summary: string;
  created_by_user_id: string;
  created_at: string;
  status: PolicyChangeStatus;
  applied_version: number | null;
}

// Story 4.4 — rabbinical approval responses.
export interface PolicyApproved {
  pr_number: number;
  merged: true;
  merge_commit_sha: string;
}

export interface PolicyChangesRequested {
  pr_number: number;
  requested_changes: true;
}

export const policyApi = {
  getPolicy: (communityId: string) =>
    filterApiFetch<PolicyPrefill>(`/v1/communities/${communityId}/policy`),
  submit: (communityId: string, form: PolicyFormWire) =>
    filterApiFetch<PolicyChangeCreated>(`/v1/communities/${communityId}/policy-changes`, {
      method: 'POST',
      body: JSON.stringify(form),
    }),
  listChanges: (communityId: string) =>
    filterApiFetch<PolicyChangeItem[]>(`/v1/communities/${communityId}/policy-changes`),
  // Story 4.4 — approve (direct merge) / request changes (PR comment).
  approve: (communityId: string, prNumber: number) =>
    filterApiFetch<PolicyApproved>(
      `/v1/communities/${communityId}/policy-changes/${prNumber}/approve`,
      { method: 'POST' },
    ),
  requestChanges: (communityId: string, prNumber: number, comment: string) =>
    filterApiFetch<PolicyChangesRequested>(
      `/v1/communities/${communityId}/policy-changes/${prNumber}/request-changes`,
      { method: 'POST', body: JSON.stringify({ comment }) },
    ),
};
